import avatarClasses from '@/styles/mantine/Avatar.module.css'
import buttonClasses from '@/styles/mantine/Button.module.css'
import modalClasses from '@/styles/mantine/Modal.module.css'
import tabsClasses from '@/styles/mantine/Tabs.module.css'
import {
	AvatarStylesNames,
	ButtonStylesNames,
	ActionIcon as MantineActionIcon,
	Avatar as MantineAvatar,
	Button as MantineButton,
	Container as MantineContainer,
	Loader as MantineLoader,
	Modal as MantineModal,
	Tabs as MantineTabs,
	TabsStylesNames,
	rem,
	ScrollArea,
} from '@mantine/core'
import clsx from 'clsx'

export const Modal = MantineModal.extend({
	defaultProps: {
		radius: rem(10),
		centered: true,
		scrollAreaComponent: ScrollArea.Autosize,
		classNames: {
			root: modalClasses.root,
			header: modalClasses.header,
			title: modalClasses.title,
			close: modalClasses.close,
		},
	},
})

export const Avatar = MantineAvatar.extend({
	defaultProps: {
		classNames: (theme, props, ctx) => {
			const classNames = props.classNames as Partial<Record<AvatarStylesNames, string>>

			return {
				root: clsx(avatarClasses.root, classNames?.root),
			}
		},
	},
})

const CONTAINER_SIZES: Record<string, number> = {
	xxs: 300,
	xs: 400,
	sm: 500,
	md: 600,
	lg: 700,
	xl: 800,
	xxl: 900,
}

export const Container = MantineContainer.extend({
	defaultProps: {
		px: 0,
	},
	vars: (_, { fluid }) => {
		return {
			root: {
				width: 'var(--container-size)',
				'--container-size': fluid ? '100%' : 'var(--page-container-width)',
			},
		}
	},
})

export const Button = MantineButton.extend({
	defaultProps: {
		variant: 'filled',
		classNames: (theme, props, ctx) => {
			const classNames = props.classNames as Partial<Record<ButtonStylesNames, string>>

			return {
				root: clsx(buttonClasses.root, classNames?.root),
				label: clsx(buttonClasses.label, classNames?.label),
			}
		},
		size: 'md',
	},
	vars: (theme, props, ctx) => {
		let bg: string | undefined = undefined
		let hover: string | undefined = undefined

		if (props.variant === 'filled') {
			bg = 'var(--bg-jike-yellow)'
			hover = 'var(--bg-jike-yellow)'
		}
		return {
			root: {
				'--button-bg': bg,
				'--button-hover': hover,
			},
		}
	},
})

export const ActionIcon = MantineActionIcon.extend({
	defaultProps: {
		variant: 'filled',
	},
	vars: (theme, { variant }, ctx) => ({
		root: {
			'--ai-bg': variant === 'filled' ? 'var(--bg-jike-yellow)' : undefined,
		},
	}),
})

export const Tabs = MantineTabs.extend({
	defaultProps: {
		classNames: (theme, props, ctx) => {
			const classNames = props.classNames as Partial<Record<TabsStylesNames, string>>

			return {
				...classNames,
				root: clsx(tabsClasses.root, classNames?.root),
				tab: clsx(tabsClasses.tab, classNames?.tab),
			}
		},
	},
	vars: () => ({
		root: {
			'--tabs-list-border-width': '3px',
			'--tab-border-color': 'var(--tint-separator, #dbdbdb)',
			'--tab-hover-color': 'var(--bg-surface-body-1)',
		},
	}),
})

export const Loader = MantineLoader.extend({
	defaultProps: {
		type: 'dots',
	},
})
